define('boxes/helpers/box-loading',['jquery'], function ($) {
    'use strict';

    function showLoading(boxInstance, addBefore) {
        var addBeforeOption = addBefore || true;
        $('.cnt-overlay', parent.document.body).applyTemplate({}, {
            template: 'loading-popup',
            into: boxInstance,
            replace: false,
            addBefore: addBeforeOption
        });
    }

    function removeLoading(boxInstance) {
        boxInstance.find('.popup').remove();
    }

    return {
        showLoading: showLoading,
        removeLoading: removeLoading
    };
});
